import { c as _c } from "react/compiler-runtime";
import { IcoChevronDown16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import type React from 'react';
import { forwardRef } from 'react';
type BaseSelectTriggerProps = {
  children: React.ReactNode | string;
  hasError?: boolean;
  hasFocus?: boolean;
  isEmpty?: boolean;
  isPrivate?: boolean;
  onClick?: () => void;
  size?: 'compact' | 'default' | 'tiny';
  testID?: string;
  hasIcon?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;
const BaseSelectTrigger = forwardRef<HTMLButtonElement, BaseSelectTriggerProps>((t0, ref) => {
  const $ = _c(42);
  let children;
  let className;
  let disabled;
  let hasError;
  let hasFocus;
  let hasIcon;
  let isEmpty;
  let isPrivate;
  let onClick;
  let props;
  let t1;
  let testID;
  if ($[0] !== t0) {
    ({
      children,
      disabled,
      hasError,
      hasFocus,
      isEmpty,
      isPrivate,
      onClick,
      size: t1,
      testID,
      hasIcon,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = disabled;
    $[4] = hasError;
    $[5] = hasFocus;
    $[6] = hasIcon;
    $[7] = isEmpty;
    $[8] = isPrivate;
    $[9] = onClick;
    $[10] = props;
    $[11] = t1;
    $[12] = testID;
  } else {
    children = $[1];
    className = $[2];
    disabled = $[3];
    hasError = $[4];
    hasFocus = $[5];
    hasIcon = $[6];
    isEmpty = $[7];
    isPrivate = $[8];
    onClick = $[9];
    props = $[10];
    t1 = $[11];
    testID = $[12];
  }
  const size = t1 === undefined ? "default" : t1;
  let t2;
  if ($[13] !== isPrivate) {
    t2 = isPrivate && {
      "data-dd-privacy": "mask"
    };
    $[13] = isPrivate;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== className) {
    t3 = cx("fp-input fp-select-trigger fp-custom-appearance", className);
    $[15] = className;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== isPrivate) {
    t4 = isPrivate && {
      "data-dd-privacy": "mask"
    };
    $[17] = isPrivate;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== children || $[20] !== hasIcon) {
    t5 = hasIcon ? children : <p className="overflow-hidden text-ellipsis whitespace-nowrap">{children}</p>;
    $[19] = children;
    $[20] = hasIcon;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== t4 || $[23] !== t5 || $[24] !== testID) {
    t6 = <span className="flex items-center overflow-hidden max-w-[calc(100%-28px)]" data-testid={testID} {...t4}>{t5}</span>;
    $[22] = t4;
    $[23] = t5;
    $[24] = testID;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  const t7 = disabled ? "tertiary" : "primary";
  let t8;
  if ($[26] !== t7) {
    t8 = <div className="flex items-center justify-center ml-3"><IcoChevronDown16 color={t7} /></div>;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== disabled || $[29] !== hasError || $[30] !== hasFocus || $[31] !== isEmpty || $[32] !== onClick || $[33] !== props || $[34] !== ref || $[35] !== size || $[36] !== t2 || $[37] !== t3 || $[38] !== t6 || $[39] !== t8 || $[40] !== testID) {
    t9 = <button data-has-error={hasError} data-has-focus={hasFocus} data-empty={isEmpty} {...t2} data-testid={testID} data-size={size} disabled={disabled} onClick={onClick} ref={ref} type="button" {...props} className={t3}>{t6}{t8}</button>;
    $[28] = disabled;
    $[29] = hasError;
    $[30] = hasFocus;
    $[31] = isEmpty;
    $[32] = onClick;
    $[33] = props;
    $[34] = ref;
    $[35] = size;
    $[36] = t2;
    $[37] = t3;
    $[38] = t6;
    $[39] = t8;
    $[40] = testID;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  return t9;
});
export default BaseSelectTrigger;